export const surfaceTransition = {
  duration: 0.25,
  ease: [0.4, 0, 0.2, 1],
} as const;

export const fadeTransition = {
  duration: 0.15,
  ease: [0.16, 1, 0.3, 1],
} as const;
